import { Component, Mixins } from 'vue-property-decorator';
import { PaymentRequirementsIncomingStore } from '../../../store/incoming';
import { PaymentRequirementsIncomingAction, PaymentRequirementsIncomingGetter, PaymentRequirementsIncomingMutation } from '../../../store/incoming/constants';
import { PaymentRequirementsItem } from '../../../api/incoming/payment-requirements-incoming.interface';
import PaymentRequirementsMapper from './PaymentRequirementsMapper';
import { IApiHandlerParams } from '@/api/interface';

@Component
export default class PaymentRequirementsIncomingLoader extends Mixins(
	PaymentRequirementsMapper
) {

	@PaymentRequirementsIncomingStore.Getter(PaymentRequirementsIncomingGetter.unprocessedList)
	readonly paymentRequirementsList!: PaymentRequirementsItem[]

	@PaymentRequirementsIncomingStore.Getter(PaymentRequirementsIncomingGetter.unprocessedListLoading)
	readonly paymentRequirementsLoading!: boolean

	@PaymentRequirementsIncomingStore.Mutation(PaymentRequirementsIncomingMutation.setUnprocessedList)
	setPaymentRequirementsList(_payload: PaymentRequirementsItem[]) {}

	@PaymentRequirementsIncomingStore.Action(PaymentRequirementsIncomingAction.loadUnprocessed)
	loadUnprocessedPaymentRequirements!: (
		handler?: IApiHandlerParams
	) => Promise<PaymentRequirementsItem[] | null>

}